import {
  Card,
  Image,
  Text,
  Badge,
  Stack,
  ActionIcon,
  Flex
} from '@mantine/core';
import { IconMinus } from '@tabler/icons-react';
import { IProduct } from '../../../interfaces/Product';
import { OrderProduct } from '../interfaces';
import { IStoreImage } from '../../../interfaces/StoreImage';
import styles from './ProductCard.module.scss';

interface ProductCardProps {
  sectionColor?: string;
  product: IProduct;
  productInOrder?: OrderProduct;
  onCardClicked: (product: IProduct, quantity: number) => void;
  handleSubtract?: (product: IProduct) => void;
  handleIncrement?: (product: IProduct) => void;
  cardIcon?: React.ReactNode;
}

const ProductCard = ({
  sectionColor = 'blue',
  product,
  productInOrder,
  onCardClicked,
  handleSubtract,
  handleIncrement,
  cardIcon
}: ProductCardProps) => {

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent card click when clicking buttons
        onCardClicked(product, 1);
    };

    const handleIncrementClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent card click
        handleIncrement?.(product);
    };

    const handleDecrementClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent card click
        handleSubtract?.(product);
    };

    return (
        <Card
            data-testid={`new-order-product-card-${product._id}`}
            shadow="md"
            radius="md"
            withBorder
            padding="xs"
            m={'xs'}
            className={styles.productCard}
            onClick={handleClick}
            style={{
                '--section-color': sectionColor
            } as React.CSSProperties}

        >
            {productInOrder?.quantity && productInOrder.quantity > 0 && (
                <Flex justify="space-between" align="center">
                    <ActionIcon
                        variant="filled"
                        color='red'
                        onClick={handleDecrementClick}
                        size="sm"
                        disabled={productInOrder?.quantity === 0}
                        style={{
                            position: 'absolute',
                            top: 4,
                            left: 4,
                            zIndex: 2
                        }}
                    >
                        <IconMinus size={'1rem'} />
                    </ActionIcon>
                    <Badge
                        color={sectionColor}
                        size="md"
                        style={{
                            position: 'absolute',
                            top: 4,
                            right: 4,
                            zIndex: 2
                        }}
                    >
                        {productInOrder.quantity}
                    </Badge>
                </Flex>
            )}

      <Stack h="100%">
        {/* Image/Name Section */}
        {/* Prioridad 1: CardIcon */}
        {cardIcon && cardIcon}

        {/* Prioridad 2: Product Image (solo si no hay cardIcon) */}
        {!cardIcon && (product.image as IStoreImage)?.resourceUrl && (
          <Image
            src={(product.image as IStoreImage).resourceUrl}
            alt={product.name}
            className={styles.productCardImage}
          />
        )}

        {/* Prioridad 3: OverlayText (solo si no hay cardIcon ni image) */}
        {!cardIcon && !(product.image as IStoreImage)?.resourceUrl && (
          <div className={styles.productCardImageText}>
            <Text size="sm" fw={500} lineClamp={3}>
              {product.overlayText || product.name}
            </Text>
          </div>
        )}

                {/* Info Section */}
                <Stack justify="flex-end" h="100%" gap={1}>
                    <Text
                        flex={1}
                        ta="center"
                        size="sm"
                        fw={'bold'}
                        lineClamp={2}
                        style={{
                            fontSize: '1rem',
                            height: '100%',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                        }}
                    >
                        {product.name}
                    </Text>

                    {/*<Group justify="center" align="space-between">
                        <ActionIcon
                            variant="filled"
                            color='red'
                            onClick={handleDecrementClick}
                            size="sm"
                            disabled={productInOrder?.quantity === 0}
                        >
                            <IconMinus size={'1rem'} />
                        </ActionIcon>
                        <ActionIcon
                            variant="filled"
                            color={'var(--mantine-washday-secondary-color)'}
                            onClick={handleIncrementClick}
                            size="sm"
                        >
                            <IconPlus size={'1rem'} />
                        </ActionIcon>
                    </Group> */}
                </Stack>
            </Stack>
        </Card>
    );
};

export default ProductCard;
